import localStorageHelper from '@/helper/localStorageHelper';
import { getLocale } from '@/plugins/i18n';

const getDBName = () => {
  const locale = getLocale();
  const cid = localStorageHelper.getCid();
  return `${cid}-${locale}`;
};

const checkForDatabase = (event, objectStore) => {
  const database = event.target.result;
  if (
    !database.objectStoreNames.contains(objectStore) ||
    event.oldVersion === 0
  ) {
    database.createObjectStore(objectStore, {
      keyPath: 'id',
      autoIncrement: true,
    });
  }
};

const indexedDBHelper = {
  setData: (objectStore, data) =>
    new Promise((resolve, reject) => {
      const indexDBName = getDBName();
      const init = indexedDB.open(indexDBName);
      let database;
      init.onupgradeneeded = (event) => {
        checkForDatabase(event, objectStore);
      };
      init.onsuccess = (event) => {
        database = event.target.result;
        const transaction = database.transaction(objectStore, 'readwrite');
        const cache = transaction.objectStore(objectStore);
        cache.getAll().onsuccess = async (eventSuccess) => {
          const values = eventSuccess.target.result;
          if (values.length > 0) {
            await cache.delete(values[0].id);
          }
          const request = cache.put(data);
          request.onsuccess = () => {
            console.info('Metadata successfully added.', request.result);
            database.close();
            resolve();
          };
          request.onerror = () => {
            console.error('Error while writing to IndexedDB', request.error);
            reject();
          };
        };
        cache.onerror = (error) => {
          console.error('Error in Cache of IndexedDB', error);
          reject();
        };
      };
    }),

  getData: (objectStore) =>
    new Promise((resolve, reject) => {
      const indexDBName = getDBName();
      const init = indexedDB.open(indexDBName, 1);
      let database;
      init.onupgradeneeded = (event) => {
        checkForDatabase(event, objectStore);
      };
      init.onsuccess = (event) => {
        database = event.target.result;
        try {
          let current = 1;
          const transaction = database.transaction(objectStore, 'readwrite');
          const cache = transaction.objectStore(objectStore);

          cache.getAll().onsuccess = async (eventSuccess) => {
            const values = eventSuccess.target.result;
            if (values.length > 0) {
              current = values[0].id;
            }
            const request = cache.get(current);
            request.onsuccess = () => {
              resolve(request.result || {});
            };
            request.onerror = (error) => {
              console.error('Metadata could not be retrieved.');
              reject(error);
            };
          };
        } catch (error) {
          reject(error);
        }
      };
      init.onerror = (error) => {
        console.error('DB not found.');
        reject(error);
      };
    }),
};
export default indexedDBHelper;
